import {
  Box,
  Stack
} from '@mui/material';
import {
  HeaderNavbar,
  StockTickerList
} from 'modules';
import {
  Outlet,
  useNavigate,
  useParams
} from 'react-router-dom';



export type LayoutProps = {};

export const Layout = (props: LayoutProps) => {
  const navigate = useNavigate();
  const { companyId } = useParams<{ companyId: string }>();

  return (
    <Box
      display='flex'
      flexDirection='column'
      paddingX='1.5rem'
    >
      <HeaderNavbar.FC />

      <Stack
        direction='row'
        gap={1}
        sx={{
          borderRadius: (theme) => theme.shape.borderRadius,
          backgroundColor: 'white'
        }}
      >
        <StockTickerList.FC
          selectedCompanyId={companyId}
          onClick={(newId) => navigate(`/sentiment/health/${newId}`)}
        />

        <Box sx={{
          flex: 1
        }}
        >
          <Outlet />
        </Box>
      </Stack>
    </Box>

  );
};
